<template>
  <div>
    <div>
      <span class="xbed-sub-title">房间详情</span>
    </div>

    <Form class="add-top-distance">
      <FormItem prop="query">
        <Button type="primary" @click="openCopyRoomSettingModal">复制房间设置</Button>
      </FormItem>
    </Form>

    <Tabs class="tabs">
      <TabPane label="基本信息" name="baseInfo" class="add-distance">
        <base-info></base-info>
      </TabPane>
      <TabPane label="扩展信息" name="extensionInfo" class="add-distance">
        <extension-info></extension-info>
      </TabPane>
      <TabPane label="设施/服务" name="service" class="add-distance">
        <service></service>
      </TabPane>
      <TabPane label="描述" name="description" class="add-distance">
        <description></description>
      </TabPane>
      <TabPane label="图片" name="material" class="add-distance">
        <material></material>
      </TabPane>
    </Tabs>

    <Modal v-model="copyRoomSettingModal.display" ref="copyRoomSettingModal" title="房间列表" :width="1000">
      <room-list></room-list>
    </Modal>

  </div>
</template>

<script>
import Utils from "../../../utils";
// import API from "../../../api";

import BaseInfo from './base-info'
import ExtensionInfo from './extension-info'
import Service from './service'
import Description from './description'
import Material from './material'
import RoomList from './room-list'

export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
  },
  data() {
    return {
      copyRoomSettingModal: {
        display: false,
      }
    }
  },
  methods: {
    openCopyRoomSettingModal() {
      this.copyRoomSettingModal.display = true;
    }
  },
  components: {
    'base-info': BaseInfo,
    'extension-info': ExtensionInfo,
    'service': Service,
    'description': Description,
    'material': Material,
    'room-list': RoomList,
  }
}
</script>


<style lang="scss" scoped>
.add-top-distance{
  margin-top: 10px;
}
.add-distance{
  padding-left: 4px;
}
</style>




// WEBPACK FOOTER //
// src/pages/room/room-detail/index.vue